export default function SectionBg({ src, position = "center", opacity = 0.14 }) {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
      <img src={src} alt="" className="w-full h-full object-cover" style={{ opacity, objectPosition: position }} loading="lazy" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, #080808 0%, rgba(8,8,8,0.45) 30%, rgba(8,8,8,0.45) 70%, #080808 100%)" }} />
    </div>
  );
}
